export default __webpack_public_path__ + "static/mapboxToken-cb99216229f1d52dccdab3ae82e209a7.png";